import { useEffect, useRef, useState } from 'react';
import {
    Badge,
    Button,
    Col,
    Dropdown,
    Form,
    InputGroup,
    Row,
    Spinner,
    Table,
} from 'react-bootstrap';
import Highlighter from 'react-highlight-words';
import { useInfiniteQuery } from 'react-query';
import { ReactComponent as ReactMoreIcon } from '../../../assets/icons/more.svg';
import NotificationIcon from '../../../constants/notificationIcon';
import { rowsPerPage } from '../../../constants/pagination';
import useIntersectionObserver from '../../../hooks/useIntersectionObserver';
import ConfirmationDialog from '../../../utils/ConfirmationDialog';
import { StyledPageTitle } from '../BranchesData/styles';
import ContactModal from './ContactModal';
import { StyledTh } from './styles';
import formatMask from '../../../utils/fotmatMask';
import ContactHttpService from '../../../services/http/contact-http';

interface ModalRegisterProps {
    data?: any;
    show?: boolean;
}

function ContactsData() {
    const [modalRegister, setModalRegister] = useState<ModalRegisterProps>({});
    const [term, setTerm] = useState('');

    function handleNewContact() {
        setModalRegister({ show: true });
    }

    function handleStoreContact(data: any) {
        setModalRegister({
            show: true,
            data,
        });
    }

    const [selectedContactId, setSelectedContactId] = useState<number | null>(
        null,
    );

    const [showRemoveContactModal, setShowRemoveContactModal] =
        useState<boolean>(false);

    async function loadItems({ pageParam = 0 }: any) {
        const params = {
            term,
            skip: pageParam,
            take: rowsPerPage,
        };

        const { data } = await ContactHttpService.readMany(params);

        return {
            data: data.results,
            currentPage: pageParam,
            pages: Math.ceil(data.metadata.total / 5),
        };
    }

    const loadMoreRef = useRef();

    const {
        data,
        fetchNextPage,
        hasNextPage,
        isLoading,
        isFetchingNextPage,
        refetch,
    } = useInfiniteQuery('contacts', loadItems, {
        // eslint-disable-next-line consistent-return
        getNextPageParam: (response: any) => {
            if (response.currentPage + 1 < response.pages) {
                return response.currentPage + 1;
            }
        },
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
    });

    const handleRemoveContact = async () => {
        if (!selectedContactId) {
            throw new Error('Contato não encontrado para exclusão');
        }
        await ContactHttpService.delete(selectedContactId);
        refetch();
    };

    useIntersectionObserver({
        target: loadMoreRef,
        onIntersect: fetchNextPage,
        enabled: hasNextPage,
    });

    useEffect(() => {
        const timer = setTimeout(() => {
            refetch();
        }, 500);

        return () => clearTimeout(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [term]);

    return (
        <>
            <Row>
                <Col>
                    <StyledPageTitle className="mt-2">Contatos</StyledPageTitle>
                </Col>
                <Col>
                    <Button
                        className="float-right w-25"
                        // eslint-disable-next-line react/jsx-no-bind
                        onClick={handleNewContact}
                    >
                        Novo contato
                    </Button>
                </Col>
            </Row>
            <Row className="mt-2">
                <Col>
                    <Row>
                        <InputGroup className="mb-3">
                            <InputGroup.Prepend>
                                <InputGroup.Text>
                                    <i className="fas fa-search" />
                                </InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control
                                type="text"
                                value={term}
                                onChange={(event) =>
                                    setTerm(event.target.value)
                                }
                                placeholder="Digite aqui o que procura..."
                            />
                        </InputGroup>
                    </Row>
                </Col>
                <Table bordered hover size="sm" className="text-center">
                    <thead>
                        <tr>
                            <StyledTh>Consultor</StyledTh>
                            <StyledTh>Whatsapp</StyledTh>
                            <StyledTh>Estados</StyledTh>
                            <StyledTh />
                        </tr>
                    </thead>
                    <tbody>
                        {data?.pages &&
                            data?.pages.map((group: any) =>
                                group?.data.map((item: any) => (
                                    <tr key={item.id}>
                                        <td>
                                            <Highlighter
                                                autoEscape
                                                highlightClassName="highlight-term"
                                                searchWords={[term]}
                                                textToHighlight={
                                                    item.consultantName
                                                }
                                            />
                                        </td>
                                        <td>
                                            <Highlighter
                                                autoEscape
                                                highlightClassName="highlight-term"
                                                searchWords={[]}
                                                textToHighlight={
                                                    formatMask(
                                                        item.phoneNumber,
                                                        '(##) #####-####',
                                                    ) as string
                                                }
                                            />
                                        </td>
                                        <td>
                                            <h5>
                                                {item.states
                                                    .split(',')
                                                    .map((state: any) => (
                                                        <Badge
                                                            style={{
                                                                margin: '1%',
                                                                backgroundColor:
                                                                    'rgba(47, 204, 139, 0.1)',
                                                                color: ' #2fcc8b',
                                                            }}
                                                            variant="light"
                                                            key={state}
                                                        >
                                                            <Highlighter
                                                                autoEscape
                                                                searchWords={[]}
                                                                highlightClassName="highlight-term"
                                                                textToHighlight={
                                                                    state
                                                                }
                                                            />
                                                        </Badge>
                                                    ))}
                                            </h5>
                                        </td>
                                        <td>
                                            <Dropdown key="left">
                                                <Dropdown.Toggle
                                                    bsPrefix="nexen"
                                                    className="mt-n3 mb-n3"
                                                    as={Button}
                                                    variant="text"
                                                >
                                                    <ReactMoreIcon
                                                        fill="#bdbdbd"
                                                        width="10"
                                                        height="20"
                                                    />
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu>
                                                    <Dropdown.Item
                                                        onClick={() =>
                                                            handleStoreContact(
                                                                item,
                                                            )
                                                        }
                                                    >
                                                        Editar
                                                    </Dropdown.Item>
                                                    <Dropdown.Item
                                                        onClick={async () => {
                                                            setSelectedContactId(
                                                                item.id,
                                                            );
                                                            setShowRemoveContactModal(
                                                                true,
                                                            );
                                                        }}
                                                    >
                                                        Remover
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </td>
                                    </tr>
                                )),
                            )}
                    </tbody>
                </Table>
                <Col md={12} className="text-center" ref={loadMoreRef as any}>
                    {(isLoading || isFetchingNextPage) && (
                        <Col md={12} className="text-center">
                            <Spinner animation="border" />
                        </Col>
                    )}
                    {data?.pages[0].data.length === 0 && (
                        <Col md={12} className="text-center">
                            <strong style={{ color: '#adadad' }}>
                                Sem itens para carregar
                            </strong>
                        </Col>
                    )}
                </Col>
            </Row>
            <ContactModal
                data={modalRegister.data}
                show={modalRegister.show}
                onHide={() => {
                    setModalRegister({});
                    refetch();
                }}
            />

            {showRemoveContactModal && (
                <ConfirmationDialog
                    show={showRemoveContactModal}
                    onHide={() => {
                        setShowRemoveContactModal(false);
                        setSelectedContactId(null);
                    }}
                    onConfirm={handleRemoveContact}
                    icon={NotificationIcon.Warning}
                    title="Excluir contato"
                    text="Deseja excluir o contato selecionado?"
                />
            )}
        </>
    );
}

export default ContactsData;
